<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :model="form" class="user-search" label-width="100px" size="small">
      <el-row>
        <el-col :span="7">
          <el-form-item label="销售订单编号">
            <el-input size="small" v-model="form.salesOrderCode" placeholder="请输入销售订单编号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="创建人">
            <el-input size="small" v-model="form.creater" placeholder="请输入创建人" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7" v-if="goodsShow == true">
          <el-form-item label="合同编号">
            <el-input size="small" v-model="form.contractCode" placeholder="请输入合同编号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3" class="text-align-right" v-if="goodsShow == true">
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-col>
        <el-col :span="7" v-if="goodsShow == true" v-show="!isFold">
          <el-form-item label="客户名称">
            <el-input size="small" v-model="form.customerName" placeholder="请输入客户名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7" v-show="goodsShow == true?!isFold:true">
          <el-form-item label="创建时间">
            <el-select v-model="form.createCondition" placeholder="请选择" style="width: 120px;" @change="createConditionChange" clearable>
              <el-option
                v-for="item in conditionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-date-picker
             v-if="form.createCondition == 'between'"
             key="0"
             class="normal-half-width"
              v-model="form.createTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00','23:59:59']"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable>
            </el-date-picker>
            <el-date-picker
            v-if="form.createCondition !== 'between' && form.createCondition !== 'auto'"
            class="normal-half-width"
            v-model="form.createTime"
            type="datetime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable>
          </el-date-picker>
          <el-select
            v-model="form.createTime"
            placeholder="请选择"
            v-if="form.createCondition == 'auto'"
            class="normal-half-width"
            :class="{'w120':form.dynamicCreateValue == '7'}"
            @change="dynamicCreateValueChange"
            clearable>
            <el-option
              v-for="item in dynamicDate"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select clearable v-model="form.createTime" placeholder="请选择" v-if="form.createCondition == 'auto' && form.dynamicCreateValue == '7'" style="margin-top: 8px;width: 120px;">
            <el-option
              v-for="item in dateOneOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-tooltip content="只支持1-365的正整数">
            <el-input-number v-if="form.createCondition == '1' && form.dynamicCreateValue == '7'" @blur="dateInputCreateBlur" v-model="form.createTime" step-strictly controls-position="right" :min="1" :max="365" style="margin-left: 8px;margin-top: 8px;width: 120px;"></el-input-number>
          </el-tooltip>
          <el-select clearable v-model="form.createTime" placeholder="请选择" v-if="form.createCondition == 'auto' && form.dynamicCreateValue == '7'" style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);">
            <el-option
              v-for="item in dateTwoOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" class="text-align-right" v-if="goodsShow == false">
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-col>
        <!-- <el-col :span="7" v-show="!isFold">
          <el-form-item label="更新人">
            <el-input size="small" v-model="form.updater" placeholder="请输入更新人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7" v-show="!isFold">
          <el-form-item label="更新时间">
            <el-select v-model="form.updateCondition" placeholder="请选择" style="width: 120px;" @change="updateConditionChange">
              <el-option
                v-for="item in conditionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-date-picker
             v-if="form.updateCondition == 'between'"
             key="0"
             class="normal-half-width"
              v-model="form.updateTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00','23:59:59']"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-date-picker
            v-if="form.updateCondition !== 'between' && form.updateCondition !== 'auto'"
            key="1"
            class="normal-half-width"
            v-model="form.updateTime"
            type="datetime"
            placeholder="请选择日期">
          </el-date-picker>
          <el-select v-model="form.updateTime" placeholder="请选择" v-if="form.updateCondition == 'auto'" class="normal-half-width" :class="{'w120':form.dynamicUpdateValue == '7'}" @change="dynamicUpdateValueChange">
            <el-option
              v-for="item in dynamicDate"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="form.updateTime" placeholder="请选择" v-if="form.updateCondition == 'auto' && form.dynamicUpdateValue == '7'" style="margin-top: 8px;width: 120px;">
            <el-option
              v-for="item in dateOneOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-tooltip content="只支持1-365的正整数">
            <el-input-number v-if="form.updateCondition == 'auto' && form.dynamicUpdateValue == '7'" @blur="dateInputUpdateBlur" v-model="form.updateTime" step-strictly controls-position="right" :min="1" :max="365" style="margin-left: 8px;margin-top: 8px;width: 120px;"></el-input-number>
          </el-tooltip>
          <el-select v-model="form.updateTime" placeholder="请选择" v-if="form.updateCondition == 'auto'&& form.dynamicUpdateValue == '7'" style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);">
            <el-option
              v-for="item in dateTwoOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-divider><i :class="!isFold?'el-icon-caret-top':'el-icon-caret-bottom'" @click="fold"></i></el-divider>
    </el-form>
  </div>
</template>
<script>
export default {
  props:['form','goodsShow'],
  data() {
    return {
      isFold:true,
      conditionOptions:[
        {
          value: "between",
          label: "选择范围"
        },
        {
          value: "lt",
          label: "小于"
        },
        {
          value: "lte",
          label: "小于等于"
        },
        {
          value: "eq",
          label: "等于"
        },
        {
          value: "gt",
          label: "大于"
        },
        {
          value: "gte",
          label: "大于等于"
        }
      ],
      dynamicDate: [{
        value: '0',
        label: '今天',
      }, {
        value: '1',
        label: '昨天'
      }, {
        value: '2',
        label: '本周'
      }, {
        value: '3',
        label: '上周'
      }, {
        value: '4',
        label: '本月'
      }, {
        value: '5',
        label: '上月'
      }, {
        value: '6',
        label: '近三月'
      }, {
        value: '7',
        label: '自定义'
      }],
      dateOneOptions:[{
        value: '过去',
        label: '过去'
      }, {
        value: '未来',
        label: '未来'
      }],
      dateTwoOptions:[{
        value: '日',
        label: '日'
      }, {
        value: '周',
        label: '周'
      }, {
        value: '月',
        label: '月'
      }, {
        value: '季度',
        label: '季度'
      }, {
        value: '年',
        label: '年'
      }],
    }
  },
  methods: {
    // 自定义时 默认给1
    dynamicCreateValueChange:function(){
      if(this.form.dynamicCreateValue == '7'){
        this.$set(this.form,'dateCreateInput','1')
      }else{
        delete this.form.dateCreateInput
      }
    },
    dynamicUpdateValueChange:function(){
      if(this.form.dynamicUpdateValue == '7'){
        this.$set(this.form,'dateUpdateInput','1')
      }else{
        delete this.form.dateUpdateInput
      }
    },
    dateInputUpdateBlur:function(){
      if(this.form.dateUpdateInput == undefined){
        this.$set(this.form,'dateUpdateInput','1')
      }
    },
    dateInputCreateBlur:function(){
      if(this.form.dateCreateInput == undefined){
        this.$set(this.form,'dateCreateInput','1')
      }
    },
    search() {
      // this.getdata(this.form)
      this.$emit('search',this.form);
    },
    fold(){
      this.isFold = !this.isFold;
    },
    createConditionChange:function(){
      this.$set(this.form,'dynamicCreateValue','')
      this.$set(this.form,'createTime','')

    },
    updateConditionChange:function(){
      this.$set(this.form,'dynamicUpdateValue','')
    },
  },
}
</script>
<style scoped>
.user-search {
  margin-top: 20px;
}
.normal-half-width{
  width: calc(100% - 132px);
  margin-left: 8px;
}
.el-divider__text{
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/assemblyWorkOrder/list-top.vue